import {get,post,put,del} from "@/api/request";

export const editRule = params =>put('/api/rule',params)
export const createRule = params =>post('/api/rule/add',params)
export const ruleList = params =>post('/api/rule/queryPage',params)
export const ruleDetail = params =>post(`/api/rule/${params.id}`)
export const ruleDel = params =>del(`/api/rule/${params.id}`)

